import { useCallback } from 'react';

/**
 * Chips / token input (piece 3): a chip row plus the Dropdown that fills it,
 * one component, with keyboard removal and not only a control to aim at.
 */
export interface Chip {
  id: string;
  label: string;
}

export interface ChipsOptions {
  value: readonly Chip[];
  onChange: (next: Chip[]) => void;
}

export function useChips({ value, onChange }: ChipsOptions) {
  const remove = useCallback((id: string) => onChange(value.filter((c) => c.id !== id)), [value, onChange]);
  /** Backspace in the empty typing field removes the last chip. */
  const removeLast = useCallback(() => {
    if (value.length > 0) onChange(value.slice(0, -1));
  }, [value, onChange]);
  const add = useCallback(
    (chip: Chip) => {
      if (value.some((c) => c.id === chip.id)) return;
      onChange([...value, chip]);
    },
    [value, onChange],
  );
  return { chips: value, count: value.length, remove, removeLast, add };
}
